import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

export const confirmationDialogSelector = createSelector(
  [(state: RootState) => state.confirmationDialog],
  ({ isOpen, title, message }) => {
    return { isOpen, title, message };
  },
);
